import { useEffect } from 'react'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[]
  push: Fbq
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

/** Laadt de Meta Pixel en registreert één PageView. */
export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (!pixelId || window.fbq) return

    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) fbq.callMethod(...args)
      else fbq.queue.push(args)
    } as Fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const first = document.getElementsByTagName('script')[0]
    if (first?.parentNode) first.parentNode.insertBefore(script, first)
    else document.head.appendChild(script)

    fbq('init', pixelId)
    fbq('track', 'PageView')
  }, [pixelId])
}
